import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutQuickInfoDistanceProfileOverride extends Layout {
    source1: DataSource;
    sourceDistanceProfileControl: DataSource;
    tableProfileOverrides: Table;
}
